@if (data.type === 'okDismissButton' || 'okButton' || 'noButtons') {
  <div>
    @if (data.title) {
      <h1 mat-dialog-title [innerHtml]="data.title | translate"></h1>
    }
    @if (data.message) {
      <div mat-dialog-content>
        <p [innerHtml]="data.message | translate"></p>
      </div>
    }
    <div mat-dialog-actions align="center">
      @if (data.type === 'okDismissButton') {
        <button mat-raised-button color="{{ data.cancelColor }}" (click)="onDismiss()">
          <span [innerHtml]="(data.dismissButtonText! | translate) || 'Cancel'">cancel</span>
        </button>
      }
      @if (data.type === 'okDismissButton' || 'okButton') {
        <button mat-raised-button color="{{ data.confirmColor }}" (click)="onOk()">
          <span [innerHtml]="(data.okButtonText! | translate) || 'Ok'">ok</span>
        </button>
      }
    </div>
  </div>
}
